import { useParams } from "react-router-dom";
import { useOrganizationById } from "src/services/hooks/organizations";

export const useOrganizationFromContext = () => {
  const { organizationId } = useParams();
  const { data: organization } = useOrganizationById(organizationId);
  return organization;
};
